import React, { Component } from 'react';
import styles from './CountrySelect.module.scss';
import countryDomains from './country-domains.json';

class CountrySelect extends Component {
  handleCountryChange = ({ target }) => {
    window.location.href = target.value;
  };

  render() {
    return (
      <select className={styles.root} onChange={this.handleCountryChange}>
        {countryDomains.map((item) => (
          <option key={item.link} value={item.link}>
            {item.country}
          </option>
        ))}
      </select>
    );
  }
}

export default CountrySelect;
